import React from 'react';

import GolfTripCard from './GolfTripCard';

function GolfTripResults({
  error,
  selectedCountrySearch,
  golfCourses,
  countryRankPrefix,
  locationType,
}) {
  return (
    <>
      <div>
        {golfCourses && golfCourses.length > 0 && (
          <div className="flex flex-col flex-nowrap justify-center items-center mx-auto mt-[400px] md:mt-20 w-full bg-slate-100">
            <h1 className="text-lg sm:text-2xl py-4">
              Your ideal golf trip is:
            </h1>
            <GolfTripCard
              golfCourses={golfCourses}
              selectedCountrySearch={selectedCountrySearch}
              countryRankPrefix={countryRankPrefix}
              locationType={locationType}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default GolfTripResults;
